import { Box, Checkbox, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getColor } from "../../style/color/color";
import { fonts } from "../../style/fonts/fonts";

export const StyledBox = styled(Box)(({ theme }) => ({
  height: "100vh",
}));
export const StyledFormBox = styled(Box)((theme) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "7px",
}));
export const UserTextFields = styled(TextField)(({ theme, label }) => ({
  maxWidth: "auto",
  marginBottom: theme.spacing("20px"),
  borderRadius: theme.spacing("10px"),
  position: "relative",
  "& .MuiOutlinedInput-root": {
    borderRadius: theme.spacing("10px"),
    "& input": {
      padding: theme.spacing("10px"),
    },
  },
}));
export const InputLabelProps = {
  color: "#505662",
  fontSize: "0.6rem",
  fontFamily: fonts.manrope,
  fontWeight: "400",
};

export const InputProps = ({ uppercase }) => ({
  color: "#171A21",
  fontSize: "1rem",
  fontFamily: fonts.manrope,
  fontWeight: "400",
  textTransform: "uppercase",
});
export const StyledCheckbox = styled(Checkbox)((theme) => ({
  position: "absolute",
  top: 0,
  left: 0,
}));

export const StyledTypography = styled(Typography)((theme) => ({
  color: "#171A21",
  fontSize: "14px",
  fontFamily: fonts.manrope,
  fontWeight: 500,
  lineHeight: "22px",

  textWrap: "balance",
  marginLeft: "50px",
  marginTop: "10px",
}));
export const StyleSpanText = styled("span")((thene) => ({
  color: "#3597EC",
  fontSize: 14,
  fontFamily: fonts.manrope,
  fontWeight: "500",
}));
export const StyledButtonBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "60%",
}));
export const ACRButtonStyles = {
  width: "100%",
  maxWidth: "300px",
  backgroundColor: getColor.primaryOrange,
  color: getColor.PrimaryWhite,
  borderRadius: "40px",
  padding: "10px",
  marginBottom: "20px",
  height: "60px",
  lineHeight: "22.2px",
  fontWeight: 700,
  fontSize: "16px",
  textAlign: "center",
  textTransform: "initial",
};
